export const parkXStyles = {
	header: {
		backgroundColor: '#1E1E1E',
	},
	sidebar: {
		backgroundColor: '#1E1E1E',
		color: 'white',
	},
	button: {
		backgroundColor: '#3f80b1ff',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#7d99aeff',
		},
	},
	text: {
		color: '#193442',
		buttonLoadingColor: '#FFFFFF',
	},
	title: {
		color: '#fff',
	},
	table: {
		headerBackgroundColor: '#cfb27b',
		headerTextColor: 'black',
	},
	platformName: {
		name: 'Park X',
	},
	logo: {
		small: {
			// Will come from an s3 bucket eventually
			src: '/parkX/parkx-icon.png',
			height: 35,
			width: 45,
		},
		large: {
			src: '/parkX/parkx-logo.png',
			height: 40,
			width: 120,
		},
	},
	favicon: {
		src: '/parkX/parkx-icon.png',
	},
	socials: {
		linkedIn: 'https://www.linkedin.com/company/parkxmanagementchci/',
	},
	siteUrl: 'https://www.parkxmanagement.com/',
	orgName: 'Park X',
};
